import React from 'react';
import { Shield, Award, Users, Target, TrendingUp, Globe } from 'lucide-react';
import Header from '../atoms/Header';
import Footer from '../atoms/Footer';
import Contact from '../atoms/Contact';
import Typography from '../components/v2/Typography';
import Button from '../components/v2/Button';
import '../scss/about.scss';
import BlogSection from '../atoms/BlogPreview';

const teamMembers = [
    {
        name: "John Anderson",
        role: "Founder & CEO",
        bio: "With over 15 years in domain investing and digital assets, John founded NameConnect to democratize access to premium domains.",
        image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop"
    },
    {
        name: "Sarah Chen",
        role: "Head of Acquisitions",
        bio: "Sarah brings 10+ years of experience in domain negotiations and has successfully brokered over $50M in domain transactions.",
        image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop"
    },
    {
        name: "Michael Roberts",
        role: "Chief Technology Officer",
        bio: "Michael leads our technical initiatives, ensuring our platform provides the best tools for domain research and valuation.",
        image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop"
    },
    {
        name: "Emily Williams",
        role: "Client Success Manager",
        bio: "Emily ensures every client receives personalized attention and achieves their domain acquisition goals efficiently.",
        image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop"
    }
];

const credibilityStats = [
    // { number: "$100M+", label: "Total Transaction Volume" },
    // { number: "10,000+", label: "Domains Brokered" },
    // { number: "5,000+", label: "Happy Clients" },
    // { number: "15+", label: "Years of Experience" }
    { number: "$2M+", label: "Total Transaction Volume" },
    { number: "1000+", label: "Domains Brokered" },
    { number: "500+", label: "Happy Clients" },
    { number: "8+", label: "Years of Experience" }
];

const achievements = [
    {
        icon: <Award size={32} />,
        title: "Industry Leader",
        description: "Recognized as one of the top domain brokerages by industry publications"
    },
    {
        icon: <Shield size={32} />,
        title: "Secure Transactions",
        description: "100% secure escrow services protecting both buyers and sellers"
    },
    {
        icon: <TrendingUp size={32} />,
        title: "Market Expertise",
        description: "Deep understanding of domain market trends and valuation metrics"
    },
    // {
    //     icon: <Globe size={32} />,
    //     title: "Global Network",
    //     description: "Extensive network of domain investors and registry partnerships worldwide"
    // }
];

export default function AboutPage() {
    return (
        <>
            <section className="services-hero-wrapper" style={{
                paddingBottom: 0
            }}>
                <div className="inner">
                    <div className="hero-heading" style={{marginBottom: 4, textAlign: "center", justifyContent: "center"}}>
                        <Typography variant="h1">About NameConnect</Typography>
                    </div>
                    <div className="hero-heading" style={{textAlign: "center", justifyContent: "center"}}>
                        <Typography variant="para">
                            Your trusted partner in premium domain acquisitions and digital asset management
                        </Typography>
                    </div>
                </div>
            </section>

            <section className="about-story-wrapper">
                <div className="inner">
                    <div className="story-content">
                        <div className="story-text">
                            <Typography variant="h2">Our Story</Typography>
                            <Typography variant="para">
                                Founded in 2008, NameConnect emerged from a simple observation: the domain industry needed a more transparent, 
                                professional, and client-focused approach to domain brokerage. What started as a small team of domain enthusiasts 
                                has grown into one of the industry's most respected brokerages.
                            </Typography>
                            <Typography variant="para">
                                We've built our reputation on trust, expertise, and results. Our team combines deep technical knowledge with 
                                exceptional negotiation skills to help clients acquire the perfect domains for their businesses. Whether you're 
                                a startup looking for your first domain or an enterprise building a portfolio, we're here to guide you through 
                                every step of the process.
                            </Typography>
                            <Typography variant="para">
                                Today, we're proud to have facilitated thousands of successful domain transactions, helping businesses 
                                establish their digital presence with premium domain names that drive growth and brand recognition.
                            </Typography>
                        </div>
                        <div className="story-stats">
                            {credibilityStats.map((stat, index) => (
                                <div key={index} className="stat-card">
                                    <Typography variant="h2">{stat.number}</Typography>
                                    <Typography variant="para">{stat.label}</Typography>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            <section className="about-mission-wrapper">
                <div className="inner">
                    <div className="mission-content">
                        <div className="mission-card">
                            <Target size={40} className="mission-icon" />
                            <Typography variant="h3">Our Mission</Typography>
                            <Typography variant="para">
                                To democratize access to premium domains by providing transparent, professional, and results-driven 
                                brokerage services that help businesses establish powerful online identities.
                            </Typography>
                        </div>
                        <div className="mission-card">
                            <Users size={40} className="mission-icon" />
                            <Typography variant="h3">Our Values</Typography>
                            <Typography variant="para">
                                Integrity, transparency, and client success drive everything we do. We believe in building long-term 
                                relationships based on trust and delivering exceptional value in every transaction.
                            </Typography>
                        </div>
                        <div className="mission-card">
                            <Globe size={40} className="mission-icon" />
                            <Typography variant="h3">Our Vision</Typography>
                            <Typography variant="para">
                                To be the global leader in domain brokerage, setting industry standards for professionalism, 
                                innovation, and client satisfaction in the digital asset marketplace.
                            </Typography>
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className="about-team-wrapper">
                <div className="inner">
                    <div className="section-header">
                        <Typography variant="h2">Meet Our Team</Typography>
                        <Typography variant="para">
                            Industry experts dedicated to your domain acquisition success
                        </Typography>
                    </div>
                    <div className="team-grid">
                        {teamMembers.map((member, index) => (
                            <div key={index} className="team-member">
                                <div className="member-image">
                                    <img src={member.image} alt={member.name} />
                                </div>
                                <div className="member-info">
                                    <Typography variant="h3">{member.name}</Typography>
                                    <Typography variant="para" className="member-role">{member.role}</Typography>
                                    <Typography variant="para">{member.bio}</Typography>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section> */}

            <section className="about-achievements-wrapper">
                <div className="inner">
                    <div className="section-header">
                        <Typography variant="h2">Why Choose NameConnect</Typography>
                        <Typography variant="para">
                            Industry recognition and proven results that speak for themselves
                        </Typography>
                    </div>
                    <div className="achievements-grid">
                        {achievements.map((achievement, index) => (
                            <div key={index} className="achievement-card">
                                <div className="achievement-icon">
                                    {achievement.icon}
                                </div>
                                <Typography variant="h3">{achievement.title}</Typography>
                                <Typography variant="para">{achievement.description}</Typography>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <BlogSection display={'both'} />

            {/* <section className="about-partners-wrapper">
                <div className="inner">
                    <div className="section-header">
                        <Typography variant="h2">Trusted By Industry Leaders</Typography>
                        <Typography variant="para">
                            We've helped Fortune 500 companies, startups, and entrepreneurs secure their perfect domains
                        </Typography>
                    </div>
                    <div className="partners-logos">
                        <div className="logo-scroll">
                            <div className="logo-item">GoDaddy Partner</div>
                            <div className="logo-item">Escrow.com Verified</div>
                            <div className="logo-item">ICANN Accredited</div>
                            <div className="logo-item">BBB A+ Rating</div>
                            <div className="logo-item">Sedo Partner</div>
                        </div>
                    </div>
                </div>
            </section> */}

            {/* <section className="about-cta-wrapper">
                <div className="inner">
                    <div className="cta-content">
                        <Typography variant="h2">Ready to Work With the Best?</Typography>
                        <Typography variant="para">
                            Let our expertise guide your next domain acquisition
                        </Typography>
                        <div className="cta-buttons">
                            <Button variant="primary" isLink={true} linkProps={{to: "/contact"}}>
                                Get Started
                            </Button>
                            <Button variant="secondary" isLink={true} linkProps={{to: "/services"}}>
                                View Our Services
                            </Button>
                        </div>
                    </div>
                </div>
            </section> */}

            <Contact />
        </>
    );
}